import { Switches } from "mui-rff";
import { Slider, Stack } from "@mui/material";
import { useField } from "react-final-form";

import { PrecipitationMapLayer } from "@/lib/api";
import { TextField } from "@/features/shared/components";

type PrecipitationConfigurationProps = {
  name: string;
  initialValue: PrecipitationMapLayer;
};

const PrecipitationConfiguration = ({
  name,
  initialValue,
}: PrecipitationConfigurationProps) => {
  const opacityEnabled = useField(`${name}.opacity_enabled`, {
    initialValue: initialValue.opacity_override !== null,
  });
  const opacityValueField = useField<number>(`${name}.opacity_override`, {
    initialValue: initialValue.opacity_override ?? 80,
  });

  return (
    <>
      <TextField
        name={`${name}.forecast_title`}
        label="Forecast label override"
        defaultValue={initialValue["forecast_title"]}
      />

      <Stack direction="row" alignItems="center">
        <div style={{ minWidth: "40%" }}>
          <Switches
            name={`${name}.opacity_enabled`}
            data={{
              label: "Override opacity",
              value: false,
            }}
          />
        </div>
        {opacityEnabled.input.value ? (
          <Slider
            {...opacityValueField.input}
            value={opacityValueField.input.value}
            min={10}
            max={100}
            valueLabelDisplay="auto"
          />
        ) : null}
      </Stack>
    </>
  );
};

export default PrecipitationConfiguration;
